import React from "react";
import { useQuoteContext } from "@/components/QuoteContextProvider";

const CONF_META = {
  explicit: { label: "Explicit in text", cls: "stamp-explicit" },
  strongly_implied: { label: "Strongly implied", cls: "stamp-implied" },
  plausible_uncertain: { label: "Uncertain", cls: "stamp-uncertain" },
};

export function ConfidenceStamp({ confidence, inferred, className = "" }) {
  const meta = CONF_META[confidence] || CONF_META.explicit;
  return (
    <span
      data-testid={`confidence-${confidence || "explicit"}`}
      className={`stamp ${meta.cls} ${className}`}
      title={inferred ? "Inferred from context" : "Supported by direct text"}
    >
      {meta.label}
      {inferred ? " · inferred" : ""}
    </span>
  );
}

export function Quote({ text, className = "" }) {
  const ctx = useQuoteContext();
  if (!text) {
    return (
      <div className={`quote-block italic text-[hsl(var(--ink-muted))] ${className}`}>
        No direct quote provided. Treat as inference.
      </div>
    );
  }
  const canExpand = Boolean(ctx && ctx.show);
  return (
    <button
      type="button"
      onClick={() => canExpand && ctx.show(text)}
      className={`quote-block text-left w-full block ${canExpand ? "cursor-pointer hover:border-[hsl(var(--ink))] transition-colors" : "cursor-default"} ${className}`}
      disabled={!canExpand}
      data-testid="quote-block"
      title={canExpand ? "Click to see full source context" : ""}
    >
      &ldquo;{text}&rdquo;
      {canExpand && (
        <span className="block text-[10px] font-mono uppercase tracking-wider text-[hsl(var(--ink-muted))] mt-1.5">
          tap for source context →
        </span>
      )}
    </button>
  );
}

export function EvidencePill({ onClick, label = "evidence" }) {
  return (
    <button type="button" className="evidence-pill" onClick={onClick} data-testid="evidence-pill">
      <span className="w-1 h-1 rounded-full bg-current" />
      {label}
    </button>
  );
}
